import * as React from 'react';
import { connect } from "react-redux";
import { capitalizeFirstLetter, getQueryParam } from "../../utils/HelperFunctions";
import axios from 'axios';
import { ROOT_URL} from '../../actions/constants';
import * as moment from "moment";
import * as _ from "lodash";
import { getScheduleElements } from '../../actions/Action_ScheduleElement';
import { getUkeplanElementsStudent } from '../../actions/Action_Ukeplan';
import { Checkbox, MessageBar, MessageBarType, PrimaryButton, Spinner, SpinnerSize } from 'office-ui-fabric-react';
import { dateStringToMoment } from '../../utils/DateUtils';
moment.locale("nb");

export interface IUkeplanSendEmailViewProps {
    scheduleElements: any;
    ukeplanelementsstudent:any;
    getScheduleElements(schoolClass: string, week: number, year: number, tilretteleggingsgruppeId?: number);
    getUkeplanElementsStudent(statedata: any,week: number,year: number);
  }

  export interface IUkeplanSendEmailViewState {
    isLoading:boolean;
    week: string;
    year: string;
    classId: string;
    studentId: string;
    studentName: string;
    students:any[];
    mode:string;
    selectedDate:any;
    isSending:boolean;
    statusMsg:string;
    studentForesattEpost:any[];
    studentLoaded:boolean;
    includeSchedule:boolean;
  }

  class UkeplanSendEmailView extends React.Component<
    IUkeplanSendEmailViewProps,
    IUkeplanSendEmailViewState
  > {
    constructor(props) {
        super(props);
      }

    componentDidUpdate() {

    }

    getForesattEpost(classId:string,studentId:string) {
        const data = {"ClassID":classId};
        axios.post(`${ROOT_URL}/GetStudents/`, data, {
            headers: {
                Authorization: localStorage.getItem('id_token'),
            },
        }).then((response) => {
            const s = response.data.find(s=>s.LoginName===studentId);
            this.setState({studentLoaded:true,studentForesattEpost:s ? s.ForesattEpost : []})
        });
    }

    getUkeplanElementsClass(classId: string, week: number, year: number) {
        axios.get(`${ROOT_URL}/GetUkeplanForClass?classId=${classId}&week=${week}&year=${year}`, {
            headers: {
                Authorization: localStorage.getItem('id_token'),
            },
        }).then((response) => {
            this.setState({students:response.data});
        });
    }

    getStudentArray() {
        if (this.state) {
            if (this.state.mode === "STUDENT" && this.props.ukeplanelementsstudent && this.state.studentLoaded) {
                return [{LoginName:this.state.studentId,Name:this.state.studentName,Courses:[...this.props.ukeplanelementsstudent.All],ForesattEpost: this.state.studentForesattEpost ? [...this.state.studentForesattEpost] : []}]
            }
            if (this.state.mode === "CLASS" && this.state.students.length > 0) {
                return this.state.students.sort((a, b) => a.Name.localeCompare(b.Name))
            }
        }
        return [];
    }

    componentDidMount() {
      // Get queryparams
      const week = getQueryParam("week");
      const year = getQueryParam("year");
      const classId = getQueryParam("classid");
      const studentId = getQueryParam("studentid");
      const studentName = getQueryParam("studentname"); 

      this.props.getScheduleElements(classId,Number(week),Number(year));
      if (studentId) {
        this.props.getUkeplanElementsStudent({LoginName:studentId},Number(week),Number(year));
        this.getForesattEpost(classId,studentId);
        }
        else {
            this.getUkeplanElementsClass(classId,Number(week),Number(year));
        }
      this.setState(
        {
          week:week,
          year:year,
          classId:classId,
          studentId:studentId,
          studentName:studentName,
          selectedDate: moment().utc().isoWeekYear(Number(year)).isoWeek(Number(week)).isoWeekday(1).toDate(),
          students:[],
          mode: studentId ? "STUDENT" : "CLASS",
          isSending:false,
          statusMsg:"",
          studentForesattEpost:[],
          studentLoaded:false,
          includeSchedule: true
        });
    }

    filterEvents() {
        // Returns an empty array if there are ScheduleElements yet
        if (_.isEmpty(this.props.scheduleElements)) {
          return [];
        }
    
        let values = _.values(this.props.scheduleElements).sort((a, b) => {
          if(a.Start < b.Start) { return -1; }
          if(a.Start > b.Start) { return 1; }
          return 0;
        });
    
        return values;
      }

    renderDay = (dayName:string, dayDate:string, items:any[]) => {
        return (
            <div className="zScheduleDay">
                <div className="zScheduleDayTitle">
                    <div className="zScheduleDayName">{dayName}</div>
                    <div className="zScheduleDayDate">{dayDate}</div>
                </div>
                <div className="zScheduleElementList">
                    {items.map((element)=>{
                        return (
                            <div className={`zScheduleElement ${element.Color} ${element.DisplayLength}`}>
                                <div className="zScheduleElementStart">{element.Start ? moment(element.Start).format("HH:mm") : ""}</div>
                                <div className="zScheduleElementTitle">{element.Title}</div>
                                <div className="zScheduleElementEnd">{element.End ? moment(element.End).format("HH:mm") : ""}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }

    onSendEmailClicked = () => {
        this.setState({isSending:true});
        const data = [];
        const studentsArray = this.getStudentArray();
        studentsArray.forEach((student) => {
            const html = document.getElementById(student.LoginName).outerHTML;
            data.push({StudentId:student.LoginName,Year:this.state.year,Week:this.state.week,Html:html,Max:1500})
        });
        axios.post(`${ROOT_URL}/SendScheduleEmail`, data, {
            headers: {
                Authorization: localStorage.getItem('id_token'),
            },
        }).then((response) => {
            this.setState({isSending:false,statusMsg:response.data});
        });
    }

    render() {
        const events = this.filterEvents();
        const studentsArray = this.getStudentArray();
        return (!!this.state && this.props.scheduleElements && studentsArray.length>0) ? (
            <>
                <div className="ms-Grid-row printEmail">
                    <div id="printOutput" className="printOutEmail">
                        <div style={{marginBottom:"10px"}}>
                            {this.state.statusMsg && (
                                <MessageBar messageBarType={MessageBarType.success}>{this.state.statusMsg}</MessageBar>
                            )}
                            {this.state.isSending && (
                                <Spinner style={{backgroundColor:"#dedede", color:"#000000"}} size={SpinnerSize.large}>Vennligst vent mens Zokrates sender ut e-post...</Spinner>
                            )}
                            <div style={{display: "flex", alignItems: "center", marginTop:"10px"}}>
                                <PrimaryButton iconProps={{iconName:"MailForward"}} disabled={this.state.isSending} text='Send epost' onClick={this.onSendEmailClicked}/>
                                <Checkbox
                                label={`Inkluder timeplan`}
                                checked={this.state.includeSchedule}
                                onChange={(ev, checked) => this.setState({includeSchedule: checked})}
                                />
                            </div>
                        </div>
                        {studentsArray.map((scItem) => {
                            return (
                            <div className="ms-Grid-row" style={{marginBottom: "1.5rem"}}>
                                <div className="ms-Grid-col ms-u-md8">
                                    <h3 className="h3PrintEmail">{scItem.Name}</h3>
                                    <ul>
                                        {scItem.ForesattEpost && scItem.ForesattEpost.map((p) => {
                                            return (
                                                <li>
                                                    <span>{p}</span>
                                                </li>
                                            )
                                            
                                        })}
                                    </ul>
                                </div>  
                            </div>
                            )
                        })}
                    </div>
                </div>        
            
            {studentsArray.map((student) => {
                return (
                    <div style={{display:'none'}}>
                    <div className="studentcontainer" data-studentname={student.Name} id={student.LoginName}>
                        <h3>{student.Name}</h3>
                        {events.length > 0 &&
                        (
                            <div style={{display: this.state.includeSchedule ? "block" : "none"}}>
                                <div className="zScheduleContainer" id={`schedule-${student.LoginName.split('@')[0].replace(".","-")}`}>
                                    {this.renderDay("Mandag",moment(this.state.selectedDate).format("DD. MMMM"),events.filter(e=>e.Day===1))}
                                    {this.renderDay("Tirsdag",moment(this.state.selectedDate).add(1,'d').format("DD. MMMM"),events.filter(e=>e.Day===2))}
                                    {this.renderDay("Onsdag",moment(this.state.selectedDate).add(2,'d').format("DD. MMMM"),events.filter(e=>e.Day===3))}
                                    {this.renderDay("Torsdag",moment(this.state.selectedDate).add(3,'d').format("DD. MMMM"),events.filter(e=>e.Day===4))}
                                    {this.renderDay("Fredag",moment(this.state.selectedDate).add(4,'d').format("DD. MMMM"),events.filter(e=>e.Day===5))}
                                </div>
                            </div>
                        ) }
                        {student.Courses.map((e)=>{
                            return ((e.News && e.News.length > 0) || (e.StudentTexts && e.StudentTexts.length > 0) || (e.StudentTasks && e.StudentTasks.length > 0)) ? (
                                <div className={`el-${student.LoginName.split('@')[0].replace(".","-")} fagdiv`} data-fagid={e.CourseID} data-login={student.LoginName.split('@')[0].replace(".","-")}>
                                    <div className="week-item-print">
                                        <div className="fag-box" id={e.CourseCategory}>
                                            <div className="panel-heading">
                                                <h2 className="itemTitle">{e.Title}</h2>
                                            </div>
                                            <div className="panel-body">
                                                <ul className="list-group">
                                                {e.News && e.News.map((news)=>{
                                                    return (
                                                        <li className="list-group-item">
                                                            <dl>
                                                                <dt>{news.Title}</dt>
                                                            </dl>
                                                            <dl className="zNewsText">
                                                                <dd dangerouslySetInnerHTML={{__html: news.TextRaw}}/>
                                                            </dl>
                                                        </li>
                                                    )
                                                    
                                                })}
                                                {e.StudentTexts && e.StudentTexts.map((text)=>{
                                                    return (
                                                        <li className="list-group-item">
                                                            <dl>
                                                                {text.Theme && (
                                                                    <h3>{text.Theme}</h3>
                                                                )}

                                                                {text.ShowKmpGoals && text.GrepCodeList &&
                                                                    <dd>
                                                                        <dl>
                                                                            <dt>Kompetansemål:</dt>
                                                                            <ul style={{listStyleType: "circle", marginLeft: "20px"}}>
                                                                                {text.GrepCodeList.map((g)=>{
                                                                                    return <li style={{marginTop: "1px"}}>{g.LPID} - {g.GrepTekst}</li>
                                                                                })}
                                                                            </ul> 
                                                                        </dl>
                                                                    </dd>
                                                                }
                                                                {text.GoalRaw && (
                                                                    <>
                                                                        <dt>Egendefinerte mål:</dt>
                                                                        <dd dangerouslySetInnerHTML={{__html: text.GoalRaw}}/>
                                                                    </>
                                                                )}
                                                                {(text.EvaluationText || text.EvaluationTextOther) && (
                                                                    <>
                                                                        <dt>Vurdering:</dt>
                                                                        <dd className="scheduleEvaluation">
                                                                            {text.EvalElements.map((evalTekst)=>{
                                                                                return (<li>{evalTekst}</li>)
                                                                            })}
                                                                        </dd>
                                                                    </>
                                                                )}
                                                                {text.TextonPremRaw && (
                                                                    <>
                                                                        <dt>Arbeid på skolen:</dt>
                                                                        <dd dangerouslySetInnerHTML={{__html: text.TextonPremRaw}}/>
                                                                    </>
                                                                )}
                                                                {text.TextRaw && (
                                                                    <>
                                                                        <dt>Arbeid hjemme:</dt>
                                                                        <dd dangerouslySetInnerHTML={{__html: text.TextRaw}}/>
                                                                    </>
                                                                )}
                                                                {text.Link && (
                                                                    <>
                                                                        <dt>Lenke:</dt>
                                                                        <dd className="planLenke">
                                                                            <a target="_blank" href={text.Link}>{text.Link}</a>
                                                                        </dd>
                                                                    </>
                                                                )}
                                                                {!(text.HideDeadline == true) && <span>
                                                                  <dt>Frist:</dt>
                                                                  <dd>{capitalizeFirstLetter(dateStringToMoment(text.Date).format("dddd").toString())} {text.DateText}</dd>
                                                                </span>} 
                                                            </dl>
                                                        </li>
                                                    )
                                                    
                                                })}
                                                {e.StudentTasks && e.StudentTasks.map((task)=>{
                                                    return(
                                                        <li className="list-group-item">
                                                            <h3>{task.WsTask.Name}</h3>
                                                            <dl>
                                                                <dd>
                                                                    <ul id={`kmp-2-${task.WsTaskID}`} className="kmpTask"></ul>
                                                                </dd>
                                                            </dl>

                                                            {task.WsTask && task.WsTask.ShowKmpGoals && task.WsTask.GrepCodeList &&
                                                                <dd>
                                                                    <dl>
                                                                        <dt>Kompetansemål:</dt>
                                                                        <ul style={{listStyleType: "circle", marginLeft: "20px"}}>
                                                                            {task.WsTask.GrepCodeList.map((g)=>{
                                                                                return <li style={{marginTop: "1px"}}>{g.LPID} - {g.GrepTekst}</li>
                                                                            })}
                                                                        </ul> 
                                                                    </dl>
                                                                </dd>
                                                            }

                                                            {task.WsTask && task.WsTask.GoalRaw && (
                                                                <dl>
                                                                    <dt>Egendefinerte mål:</dt>
                                                                    <dd dangerouslySetInnerHTML={{__html: task.WsTask.GoalRaw}} />
                                                                </dl>
                                                            )}
                                                            {(task.WsTask && (task.WsTask.EvaluationText || task.WsTask.EvaluationTextOther)) && (
                                                                <>
                                                                    <dt>Vurdering:</dt>
                                                                    <dd className="scheduleEvaluation">
                                                                        {task.WsTask.EvalElements.map((evalTekst)=>{
                                                                            return (<li>{evalTekst}</li>)
                                                                        })}
                                                                    </dd>
                                                                </>
                                                            )}
                                                            <dl>
                                                                <dt>Beskrivelse:</dt>
                                                                <dd dangerouslySetInnerHTML={{__html: task.WsTask ? task.WsTask.TextRaw : ''}} />
                                                            </dl>
                                                            {(task.WsTask && task.WsTask.Link) && (
                                                                <>
                                                                    <dt>Lenke:</dt>
                                                                    <dd>
                                                                        <a target="_blank" href={task.WsTask.Link}>{task.WsTask.Link}</a>
                                                                    </dd>
                                                                </>
                                                            )}
                                                            {(task.WsTask.HideDeadline != true) && <span>
                                                              <dt> Frist</dt>
                                                              <dd>{capitalizeFirstLetter(dateStringToMoment(task.WsTask.Deadline).format("dddd").toString())} {task.WsTask.Deadlinetekst}</dd>
                                                            </span>
                                                            }
                                                        </li>
                                                    );
                                                        
                                                })}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null
                        })}
                    </div>
                    </div>
                )
            })}
            
            </>
      ) : (
        <>
            <Spinner size={SpinnerSize.large}>Vennligst vent...</Spinner>
        </>
      )
    }
  }

  const mapStateToProps = (state) => {
    return {
      scheduleElements: state.scheduleElements,
      ukeplanelementsstudent: state.ukeplanelements.ukeplanelementsstudent
    };
  };

  export default connect(mapStateToProps,{getScheduleElements,getUkeplanElementsStudent})(UkeplanSendEmailView);